export default "__VITE_ASSET__cf927f50__"